const validateDownloadFormat = (params) => {
  if (params?.format && !["excel", "pdf"].includes(params.format)) {
    throw new Error("Invalid format. strictly allowed 'excel' or 'pdf'");
  }
};

// Split out of apis/MyFPO/memberApi.js — per mybusiness.md §3-4, Share Transfer is proxied
// (shared), unlike Member CRUD which stays MyFPO-only / gets a fresh MyBusiness implementation.
export const createShareTransferApi = (api) => ({
  getShareTransfer: (fpoId) => api.get(`/fpo/${fpoId}/transfer`),
  createShareTransfer: (fpoId, data) => api.post(`/fpo/${fpoId}/transfer`, data),
  updateShareTransfer: (fpoId, id, data) => api.patch(`/fpo/${fpoId}/transfer/${id}`, data),
  getShareTransferById: (fpoId, id) => api.get(`/fpo/${fpoId}/transfer/${id}`),
  deleteShareTransferById: (fpoId, id) => api.delete(`/fpo/${fpoId}/transfer/${id}`),
  getShareTransferByMemberId: (fpoId, memberId) => api.get(`/fpo/${fpoId}/member/${memberId}/transfer`),
  downloadShareTransfer: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/transfer/download`, { params, responseType: "blob" });
  },
});
